import { HttpPrefixDirective } from 'components/httpPrefix/httpPrefix.directive';

import template from './addLink.html';
import './addLink.scss';

export const AddLink = angular
    .module('app.pages.editstore.menuEditor.addLink', [
        HttpPrefixDirective
    ]).component('menuEditorAddLink', {
        template,
        bindings: {
            prefillLinkData: '<',
            onCancelClick: '&',
            onLinkSaved: '&'
        },
        controller: class MenuEditorAddLinkCtrl {
            $onInit() {
                this.linkData = this.prefillLinkData || {};
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/menuEditor/addLink.js